import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { RaButtonComponent } from '@shared/components';

@Component({
    selector: 'not-found',
    templateUrl: './not-found.html',
    styleUrl: './not-found.scss',
    imports: [RaButtonComponent, TranslatePipe],
})
export class NotFoundPage {
    // * Injects
    private _router = inject(Router);

    public navigateToHome(): void {
        this._router.navigate(['/']);
    }
}
